// GetFileAPI.js
export const PostFileAPI = async (apiAxios, url, fileNameFallback = "", registro = []) => {
    try {

        const response = await apiAxios.post(
            url,
            registro,
            {
                responseType: "blob"
            });

        if (response.status !== 200 && response.status !== 201) {
            return {
                success: false,
                errorMessage: "Erro ao fazer download do arquivo.",
            };
        }

        // Descobre o tipo de arquivo pelo header
        const contentType = response.headers["content-type"] || "application/octet-stream";
        const fileName =
            fileNameFallback ||
            (response.headers["content-disposition"]
                ? response.headers["content-disposition"].split("filename=")[1]?.replace(/"/g, "")
                : "arquivo");

        const blob = new Blob([response.data], { type: contentType });
        const urlBlob = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = urlBlob;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(urlBlob);

        return {
            success: true,
            errorMessage: "",
        };
    } catch (err) {
        return {
            success: false,
            errorMessage: "Erro ao fazer download do arquivo.",
        };
    }
};
